import axios from 'axios';
import BaseService from './BaseService';
import { PROVIDER_API_URL } from '../utils/urls';

const PROVIDER_API_TOKEN = '8a0b1d6ee0c33ee0b5a663ecce6288a46455f2a4a65f458f095bbd40aab552fb';

// Configure axios with default headers
const apiClient = axios.create({
  headers: {
    'x-api-token': PROVIDER_API_TOKEN
  }
});

export const getAllProviders = async (filters = {}) => {
  try {
    const response = await apiClient.get(`${PROVIDER_API_URL}/api/provider`);
    return response.data;
  } catch (error) {
    console.error('Error fetching providers:', error);
    throw error;
  }
};

export const getProviderById = async (id) => {
  try {
    const response = await apiClient.get(`${PROVIDER_API_URL}/api/provider/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching provider with id ${id}:`, error);
    throw error;
  }
};

export const saveClinicianData = async (id, data) => {
  try {
    const response = await apiClient.patch(`${PROVIDER_API_URL}/api/provider/${id}/fields`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating provider:', error);
    throw error;
  }
};

export const saveClinicianEmail = async (id, email) => {
  try {
    const response = await apiClient.put(`${PROVIDER_API_URL}/api/provider/contacts/${id}`, { email });
    return response.data;
  } catch (error) {
    console.error('Error updating provider:', error);
    throw error;
  }
};

// Create a class that extends BaseService for AMD-related methods
class Clinician2ServiceClass extends BaseService {
  /**
   * Fetches AMD columns for clinicians
   * @returns {Promise<Array>} Array of AMD columns with column_id, column_heading, first_name, and last_name
   */
  async getAMDColumns() {
    try {
      // Check if we have a valid token before making the API call
      const token = this.getToken();
      if (!token) {
        console.error('No authentication token found. User might not be logged in.');
        throw new Error('Authentication required');
      }
      
      return await this.get('/api/amd-columns');
    } catch (error) {
      console.error('Error fetching AMD columns:', error);
      throw error;
    }
  }

  /**
   * Fetches appointment types for clinicians
   * @returns {Promise<Array>} Array of appointment types with id and title
   */
  async getClinicianAppointmentTypes() {
    try {
      // Check if we have a valid token before making the API call
      const token = this.getToken();
      if (!token) {
        console.error('No authentication token found. User might not be logged in.');
        throw new Error('Authentication required');
      }
      
      return await this.get('/api/appointment-types');
    } catch (error) {
      console.error('Error fetching clinician appointment types:', error);
      throw error;
    }
  }
}

// Create an instance of the service
const Clinician2ServiceInstance = new Clinician2ServiceClass();

// Export the instance methods for AMD-related functionality
export const getAMDColumns = Clinician2ServiceInstance.getAMDColumns.bind(Clinician2ServiceInstance);
export const getClinicianAppointmentTypes = Clinician2ServiceInstance.getClinicianAppointmentTypes.bind(Clinician2ServiceInstance); 